import _ from 'lodash';

import createReducer from './_createReducerHelper';

export const BOARD = 'board/BOARD';
export const CHARTS = 'board/CHARTS';
export const UPDATE_SELECTED_CHART = 'board/UPDATE_SELECTED_CHART';
export const SELECTED_CHART_ID = 'board/SELECTED_CHART_ID';
export const RENDER_REQUIRED = 'board/RENDER_REQUIRED';

const initialState = {
  board: null,
  charts: [],
  selectedChartId: null,
  renderRequired: false,
};

/** ********************************************
 * reducer
 ******************************************** */

export default createReducer(initialState, {
  [BOARD]: (state, { payload }) => ({ ...state, board: payload }),
  [CHARTS]: (state, { payload }) => ({ ...state, charts: payload }),
  [UPDATE_SELECTED_CHART]: (state, { payload }) => { // replace selected chart with inbound chart
    const charts = state.charts.map((chart) => (chart.id === state.selectedChartId
      // eslint-disable-next-line no-undef
      ? _.cloneDeep(payload)
      : chart));
    return { ...state, charts, renderRequired: true };
  },
  [SELECTED_CHART_ID]: (state, { payload }) => ({ ...state, selectedChartId: payload, renderRequired: true }),
  [RENDER_REQUIRED]: (state, { payload }) => ({ ...state, renderRequired: payload }),
});

/** ********************************************
 * actions
 ******************************************** */

/**
 *
 * @param board
 * @return {{type, payload: *}}
 */
export const setBoard = (board) => ({
  type: BOARD,
  payload: board,
});

/**
 *
 * @param charts
 * @return {{type, payload: *}}
 */
export const setCharts = (charts) => ({
  type: CHARTS,
  payload: charts,
});

/**
 *
 * @param chartId
 * @return {{type, payload: *}}
 */
export const selectedChartId = (chartId) => ({
  type: SELECTED_CHART_ID,
  payload: chartId,
});

/**
 *
 * @param chart
 * @return {{type, payload: *}}
 */
export const updateSelectedChart = (chart) => ({
  type: UPDATE_SELECTED_CHART,
  payload: chart,
});

/**
 *
 * @param bool
 * @return {{type, payload: *}}
 */
export const renderRequired = (bool) => ({
  type: RENDER_REQUIRED,
  payload: bool,
});

/** ********************************************
 * selectors
 ******************************************** */

/**
 *
 * @param state
 */
export const readStateBoard = (state) => state.board.board;

/**
 *
 * @param state
 */
export const readStateCharts = (state) => state.board.charts;

/**
 *
 * @param state
 */
export const readStateSelectedChart = (state) => (state.board.charts
  ? state.board.charts.find((chart) => chart.id === state.board.selectedChartId)
  : null);
